import type { ReactNode } from 'react';

interface PreviewCardProps {
  title: string;
  children?: ReactNode;
}

export const PreviewCard = ({ title, children }: PreviewCardProps) => (
  <div className="max-h-[440px] overflow-y-auto overscroll-contain rounded-md border border-input bg-white px-4 py-3 text-sm shadow-lg">
    <div className="mb-2 font-medium break-words">{title}</div>
    {children}
  </div>
);
